import { App } from 'vue'
import Collapse from './LpCollapse.vue'

Collapse.install = (Vue: App) => {
  Vue.component(Collapse.name, Collapse)
}

export default Collapse
